import qs from 'qs';
import request from '../index';
/** 和样机管理有关的接口 **/

/** 
* PrototypeRegistration
* @params {string} data.activationTime 激活时间
* @params {string} data.applicant 申请人
* @params {string} data.applicantDept 申请人部门
* @params {string} data.applicantPhone 申请人电话
* @params {string} data.customerReceiptDetails 客户收货详细信息
* @params {string} data.expiresDate 过期时间
* @params {string} data.gpsLocation GPS最新位置
* @params {number} data.id 
* @params {string} data.notes 备注
* @params {string} data.prototypeAccessory 样机配件
* @params {string} data.prototypeSerial 样机机身号
* @params {string} data.prototypeType 样机设备类型
* @params {number} data.remainingDays 剩余天数
* @params {array} data.serialUsageList 
* @params {number} data.status 设备状态 1：未激活，2：客户试用，3：到期，4：样机转销售机，5：结束
* @params {string} data.syncTime 同步时间
* @params {string} data.trialCustomerType 试用客户类型
* @params {number} data.trialDays 试用天数
*/

/** 
* SerialGPS
* @params {string} data.address 地址
* @params {number} data.id 
* @params {string} data.lat 纬度
* @params {string} data.localDate 
* @params {string} data.lon 经度
* @params {number} data.prototypeRegistrationId 
* @params {string} data.radius 半径
* @params {string} data.serial 设备机身号
* @params {string} data.serialType 设备类型
*/

/** 
* 删除样机
* @params {array} ids
*/
export const deletePrototypeRegistration = (data) => request.delete('/api-qc/deletePrototypeRegistration', {data});

/** 
* 删除定位信息
* @params {array} ids
*/
export const deleteSerialGPS = (data) => request.delete('/api-qc/deleteSerialGPS', data);

/** 
* 样机列表导出
* @params {array} ids
*/
export const exportPrototype = (data) => request.post('/api-qc/exportPrototype', data, { responseType: 'blob' });

/** 
* 获得样机列表
* @params {string} params.applicant 申请人
* @params {string} params.applicantDept 申请部门
* @params {number} params.lineNum 每页显示多少条
* @params {boolean} params.lt3Days 剩余时间是否小于3天
* @params {number} params.pageNum 页码
* @params {string} params.prototypeSerial 样机机身号
* @params {string} params.prototypeType 样机型号
* @params {boolean} params.status 样机状态
*/
export const getPrototypeRegistrationList = (params) => request.get('/api-qc/getPrototypeRegistrationList', { params });

/** 
* 设备使用统计
*/
export const getPrototypeStatistics = (params) => request.get('/api-qc/getPrototypeStatistics', { params });

/** 
* 根据样机id获取历史定位记录
* @params {string} params.prototypeRegistrationId 样机id
*/
export const getSerialGPSByPrototypeRegistrationId = (params) => request.get('/api-qc/getSerialGPSByPrototypeRegistrationId', { params });

/** 
* 获得设备使用情况
* @params {string} params.serial 设备机身号
*/
export const getSerialUsageBySerial = (params) => request.get('/api-qc/getSerialUsageBySerial', { params });

/** 
* 修改到期时间
* @params {string} params.expiresDate expiresDate
* @params {number} params.id id
*/
export const modifyExpiresDate = (params) => request.get('/api-qc/modifyExpiresDate', { params });

/** 
* 样机激活
* @params {string} params.prototypeSerial prototypeSerial
*/
export const prototypeActivation = (params) => request.get('/api-qc/prototypeActivation', { params });

/** 
* 样机同步
* @params {number} params.id id
*/
export const prototypeSync = (params) => request.get('/api-qc/prototypeSync', { params });

/** 
* 样机登记
* @params {PrototypeRegistration} prototypeRegistration
*/
export const savePrototypeRegistration = (data) => request.post('/api-qc/savePrototypeRegistration', data);

/** 
* 上传设备定位信息
* @params {SerialGPS} serialGPS
*/
export const uploadSerialGPS = (data) => request.post('/api-qc/uploadSerialGPS', data);

/** 
* 上传设备使用情况
* @params {array} list
*/
export const uploadSerialUsage = (data) => request.post('/api-qc/uploadSerialUsage', data);

/**
 * 钉钉样机申请同步
*/
export const syncDingtalkPrototype = (params) => request.get('/api-qc/syncDingtalkPrototype', { params });

/**
 * 获得设备使用情况
*/
export const getSerialUsageByPrototypeRegistrationId = (params) => request.get('/api-qc/getSerialUsageByPrototypeRegistrationId', { params });
